<template>
  <b-form-input v-model="text" debounce="500" :placeholder="searchPlaceholder || 'Rechercher...'"/>
</template>

<script>
export default {
  name: "GmbSearchField",

  components: {},

  props: {
    searchPlaceholder: String,
  },

  data() {
    return {
      text: "",
    };
  },

  computed: {},

  watch: {
    text(newValue) {
      this.$emit("search-updated", newValue);
    },
  },

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";
@import "@/sass/settings/fonts";

/* =========================================================================
 * SEARCH FIELD
 * ========================================================================= */

.gmb-search-field {
  font-weight: bold !important;
  letter-spacing: 2px;

  &::placeholder {
    // text-transform: uppercase;
    font-size: $gmb-font-size-smaller-2;
  }

  &:not(.gmb-search-field--filled) {
    border-color: $gmb-color-black !important;
    color: $gmb-color-black !important;

    &::placeholder {
      color: $gmb-color-black !important;
    }
  }

  &--filled,
  &:focus {
    border-color: $gmb-color-white !important;
    color: $gmb-color-white !important;

    &::placeholder {
      color: $gmb-color-white !important;
    }
  }

  &--filled {
  }
}
</style>
